// Tracker version agnostic function to track usage
function trackPerConfig(tracker, appName, eventName, properties) {
  // Early return if tracker is undefined
  if (!tracker) {
    return;
  }

  // Check if this is a standalone tracker by looking at its config
  const trackerConfig = tracker.getConfig();
  const props = typeof properties === 'function' ? properties() : properties;
  if (trackerConfig && trackerConfig.standalone === true) {
    const standaloneTracker = tracker;
    standaloneTracker.track(appName, eventName, props);
  } else {
    const nonStandaloneTracker = tracker;
    nonStandaloneTracker.track(eventName, props);
  }
}
export default trackPerConfig;